<template>
  <div class="set-search" v-loading="!availableSheets">
    <div class="row">
      <div class="row-title">查找数量</div>
      <el-radio-group v-model="searchData.oneFlag" class="mTop10" @change="changeExtra">
        <el-radio :label="true">单条</el-radio>
        <el-radio :label="false">
          多条
          <el-tooltip effect="dark" placement="bottom">
            <div slot="content">
              从一个指定工作表的视图中得到符合条件
              <br />
              的批量数据（最多不超过5000条），供流
              <br />
              程中的计算节点批量操作。
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-radio>
      </el-radio-group>
    </div>
    <div class="row">
      <div class="row-title">选择工作表</div>
      <div class="row-body">
        <tree-select
          v-model="searchData.sheetId"
          :group-list="availableSheets | translateAvailableSheets"
          @input="changeEvent"
        ></tree-select>
      </div>
    </div>
    <div class="row">
      <div class="row-title">选择字段</div>
      <div class="row-body">
        <limit-field :search-data="searchData" :fields-info-map="controlMap"></limit-field>
      </div>
    </div>
    <div class="row">
      <div class="row-title">设置筛选条件</div>
      <div class="row-body">
        <condition-list
          ref="conditionList"
          :conditions="searchData.condition"
          :search-sheet="curSheet"
          :workflow-var-list="workflowVarList"
          from="workflow_search"
        ></condition-list>
      </div>
    </div>
    <div class="row">
      <div class="row-title">排序</div>
      <el-radio-group v-model="searchData.random" class="mTop10" @change="clearSort">
        <el-radio :label="false">按序查找</el-radio>
        <el-radio :label="true">随机查找</el-radio>
      </el-radio-group>
      <div class="sort-setting mTop10" v-if="searchData.sheetId && !searchData.random">
        <normal-select
          size="normal"
          :selectList="allControlsInfo"
          :selectedItem.sync="sort.key"
          style="margin-right: 10px"
        ></normal-select>
        <normal-select
          size="normal"
          :select-list="options"
          :selectedItem.sync="sort.direction"
        ></normal-select>
      </div>
    </div>
    <div class="row count" v-if="!searchData.oneFlag">
      <div class="row-title">限制数量</div>
      <el-radio-group :value="limit" class="mTop10" @input="clearData">
        <el-radio label="noLimit">不限制</el-radio>
        <el-radio label="size">条数</el-radio>
        <el-radio label="sizePercent">百分比</el-radio>
      </el-radio-group>
      <div v-if="limit === 'size'" class="mTop10">
        <el-input-number
          v-model="searchData.size"
          :controls="false"
          :max="5000"
          class="number"
        ></el-input-number>
      </div>
      <div v-else-if="limit === 'sizePercent'" class="percent mTop10">
        <el-input-number
          v-model="searchData.sizePercent"
          :min="0"
          :max="100"
          :controls="false"
          class="number"
        ></el-input-number>
        <span class="unit">%</span>
      </div>
    </div>
  </div>
</template>

<script>
import TreeSelect from "@/components/UIComponents/TreeSelect"
import Filters from "@/views/Backend/AdminEdit/Workflow/mixin/filters"
import mixin from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/mixin"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { systemControls, options } from "@/views/Backend/AdminEdit/Workflow/components/static"
import LimitField from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/LimitField"
import { getAllDefaultControls } from "@/api/sheet/sheet"

export default {
  name: "set-search",
  components: { LimitField, NormalSelect, ConditionList, TreeSelect },
  props: {
    searchData: Object,
    extra: Object,
    availableSheets: Array,
    flowConnectedData: Array
  },
  data() {
    return {
      systemControls,
      options,
      isSize: true,
      sort: {
        direction: "ASC",
        key: "cat"
      },
      controlTypeMap: {}
    }
  },
  mixins: [Filters, mixin],
  computed: {
    sheetMap() {
      return this._.keyBy(
        (this.availableSheets || []).flatMap(t => t.sheets),
        "sheetId"
      )
    },
    curSheet() {
      return this.sheetMap[this.searchData.sheetId] || {}
    },
    allControls() {
      return (this.curSheet.controls || []).concat(this.systemControls)
    },
    allControlsInfo() {
      return this.allControls.map(control => ({
        label: control.name,
        value: control._cid
      }))
    },
    controlMap() {
      return this._.keyBy(
        this.allControls.map(control =>
          Object.assign({}, control, {
            name: `[${this.controlTypeMap[control._type]}] ${control.name}`
          })
        ),
        "_cid"
      )
    },
    limit() {
      let result = "noLimit"
      if (this.searchData.size) result = "size"
      else if (this.searchData.sizePercent) result = "sizePercent"
      return result
    },
    workflowVarList() {
      let result = {}
      let sheet = {}
      if (this.searchData.sheetId) {
        sheet = {
          name: "工作表本身变量",
          vars: this.curSheet.controls.map(control => ({
            name: control.name,
            control: control,
            expresion: control._cid
          })),
          groups: []
        }
        result = this.flowConnectedData.push(sheet)
      } else {
        result = this.flowConnectedData
      }
      return this.flowConnectedData
    }
  },
  created() {
    getAllDefaultControls().then(
      controls =>
        (this.controlTypeMap = controls.reduce(
          (acc, cur) => Object.assign(acc, { [cur._type]: cur.name }),
          {}
        ))
    )
    this.init()
  },
  methods: {
    init() {
      this._.flatten(this.searchData.condition).forEach(t => this.transOldObjArr(t.varItems))
      let keys = this._.keys(this.searchData)
      if (!keys.includes("size")) this.$set(this.searchData, "size", null)
      if (!keys.includes("sizePercent")) this.$set(this.searchData, "sizePercent", null)
      if (!keys.includes("sorts")) this.$set(this.searchData, "sorts", [])
      if (!keys.includes("fieldInfos")) this.$set(this.searchData, "fieldInfos", null)
      this.sort = this.searchData.sorts[0] ? this.searchData.sorts[0] : this.$options.data().sort
    },
    changeEvent() {
      this.searchData.fieldInfos = []
      this.clearSort()
      this.changeExtra()
    },
    changeExtra() {
      if (this.searchData.sheetId && this._.isEmpty(this.searchData.oneFlag)) {
        let sheetName = this.curSheet.name
        this.$set(this.extra, "description", {
          sheetName: sheetName,
          oneFlag: this.searchData.oneFlag ? "单条" : "多条"
        })
      }
    },
    clearData(val) {
      switch (val) {
        case "noLimit":
          this.searchData.size = null
          this.searchData.sizePercent = null
          break
        case "size":
          this.searchData.size = 20
          this.searchData.sizePercent = null
          break
        case "sizePercent":
          this.searchData.size = null
          this.searchData.sizePercent = 10
          break
      }
    },
    clearSort() {
      this.sort = this.$options.data().sort
    }
  }
}
</script>

<style lang="scss" scoped>
.set-search {
  .row {
    font-size: 13px;
    padding-bottom: 15px;
    .row-title {
      font-weight: bold;
    }
    .row-tip {
      color: #9e9e9e;
    }
    .row-body {
      margin-top: 10px;
    }
    .sort-setting {
      display: flex;
    }
  }
  .count {
    .percent {
      display: flex;
      align-items: center;
      position: relative;
      .unit {
        position: absolute;
        right: 8px;
      }
    }
    .number {
      width: 100%;
    }
    ::v-deep {
      .el-input-number .el-input__inner {
        text-align: left;
      }
    }
  }
}
</style>
